import Actions from '../../odata/actions';

const actions = new Actions('userSetting', 'userSettings');

export default actions;
